import {triggerDestinationEmptySearchErrorEdapEvent, triggerSearchQuerySubmittedEdapEvent, triggerSearchSubmitEdapEvent} from './edap';
import {removeTripCookieChildrenAges, removeTripCookieDates, setTripCookieChildrenAges} from './cookies';
import {getSearchData} from './search';
import {hasValidDestinationValues} from './destination';
import {hasFilledDatesValues} from './dates';
import {isHPDestinationEmptySearchErrorExperimentAvailable, runErrorStatesOnSearchFormExperiment} from './experiments';

function showFormSummary(mediaSettings, formOptions) {
    const {
        isMobile
    } = mediaSettings;

    const {
        allowSummary
    } = formOptions;

    return isMobile && allowSummary;
}

function saveChildrenAgesTripCookie(childrenCount, ageData) {
    if (childrenCount) {
        const childrenAges = ageData.map((age) => isNaN(parseInt(age.value, 10)) ? '-' : parseInt(age.value, 10));
        setTripCookieChildrenAges(childrenAges);
    } else {
        removeTripCookieChildrenAges();
    }
}

function submitForm(trackingContext, systemOptions, abacusStore, edapOptions, latestSearchValues, formActions, formEvents, formSettings, destinationActions, latestDestinationValues, latestDatesValues, latestGuestsValues) {
    const {
        setIsSubmitting: setIsFormSubmitting,
        setHasSubmitted: setHasFormSubmitted,
        setHasSubmittedSuccessfully: setHasFormSubmittedSuccessfully,
        setWasLastSubmittedSuccessfully: setWasFormLastSubmittedSuccessfully
    } = formActions;

    const {
        onSubmit
    } = formEvents;

    const {
        setIsTypeaheadInputFocus: setIsDestinationTypeaheadInputFocus
    } = destinationActions;

    setHasFormSubmitted(true);

    if (!hasValidDestinationValues(latestDestinationValues)) {
        const shouldRunErrorStatesOnSearchFormExperiment = runErrorStatesOnSearchFormExperiment({shouldLogExperiment: true}, abacusStore, formSettings, false);

        setWasFormLastSubmittedSuccessfully(false);
        setIsDestinationTypeaheadInputFocus(!shouldRunErrorStatesOnSearchFormExperiment);

        if (isHPDestinationEmptySearchErrorExperimentAvailable(abacusStore, systemOptions, latestDestinationValues)) {
            triggerDestinationEmptySearchErrorEdapEvent(trackingContext);
        }

        return;
    }

    setIsFormSubmitting(true);

    if (!hasFilledDatesValues(latestDatesValues)) {
        removeTripCookieDates();
    }

    triggerSearchSubmitEdapEvent(trackingContext, edapOptions, latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues);
    triggerSearchQuerySubmittedEdapEvent(trackingContext, edapOptions);

    const searchData = getSearchData(latestSearchValues, latestDestinationValues, latestDatesValues, latestGuestsValues);

    setTimeout(function stopSubmitting() {
        setIsFormSubmitting(false);
    }, 3583);

    setHasFormSubmittedSuccessfully(true);
    setWasFormLastSubmittedSuccessfully(true);
    saveChildrenAgesTripCookie(searchData.childrenCount, searchData.ageData);

    onSubmit(searchData);
}

export {
    saveChildrenAgesTripCookie,
    showFormSummary,
    submitForm
};
